module.exports = __webpack_public_path__ + "static/media/settings.beeeb69d.svg";